export default __webpack_public_path__ + "static/media/fundoGeladeira.6b589217.png";